export enum ReflectionIdcardTypeEnum {
  Idcard = 'idcard',
  MainlandPassForHkAndMacao = 'mainland_pass_for_hk_and_macao',
  MainlandPassForTaiwan = 'mainland_pass_for_taiwan',
  Passport = 'passport',
  Other = 'other',
}
